// Module
var code = "<div style=\"position:relative\" class=\"donut-chart\"> <highchart id=\"$ctrl.chartContainerId\" config=\"$ctrl.config\"></highchart> </div> ";
// Exports
module.exports = code;